import { DEPLOY_TYPE, DOMAIN_URL } from 'utils';

/**
 * 나이스 팝업
 * --
 */
export const openAuthPopup = () => {
  const port = DEPLOY_TYPE === 'local' ? ':3000' : '';
  const protocol = window.location.protocol;
  // const sub = DEPLOY_TYPE === 'development' ? 'jm-coffee.' : '';
  const sub =
    DEPLOY_TYPE === 'development'
      ? 'mall-jm-coffee.'
      : DEPLOY_TYPE === 'local'
      ? ''
      : 'mall.';

  const URL = `${protocol}//${sub}${DOMAIN_URL}${port}/#/auth`;
  const popup = window.open(
    URL,
    'popupChk',
    'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no'
  );

  if (popup) {
    popup.focus();
    return;
  } else {
    window.alert('팝업 차단을 해제해주세요.');
    return;
  }
};
